import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
import { mergeSx } from "../system";
import { Grid } from "./Grid";
export const stackClasses = {
    root: "MinervaStack-root",
};
/**
 * The Stack component is a low level div that facilitates easy creation of a flex
 * containers and their flex children. This component exposes common flexbox CSS
 * properties on its root API for ease of use. It extends the Grid component to
 * provide a similar experience to the Grid component but as a flex column environment.
 *
 * @example `<Stack container justifyContent="space-between" gap={2}/>`
 *
 * @returns JSX.Element (jsx import modified to be EmotionJSX.Element)
 */
export const Stack = forwardRef(({ flexDirection = "column", flexWrap = undefined, className, sx, ...props }, ref) => {
    return (_jsx(Grid, { ref: ref, className: clsx([className, stackClasses.root]), sx: mergeSx({
            boxSizing: "border-box",
            display: "flex",
            flexDirection,
            flexWrap,
        }, sx), ...props }));
});
//# sourceMappingURL=Stack.js.map